import { useMutation } from "react-query";
import { updateType } from "../../../../actions/Utilities/BusinessLicensesPermitsType";
import { toast } from "components/toastNotification";
import { IBusLicensePermitType } from "../types";

const useEditType = () => {
  const { mutate } = useMutation(
    (Data: IBusLicensePermitType) => updateType(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Business License Permit Type Updated Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Business License Permit Type Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Business License Permit Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Business License Permit Type failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire(
              "Updating Business License Permit Type failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire(
              "Updating Business License Permit Type failed",
              `${res.Message}`,
              "error"
            );
        }
      },
      onError: (error: any) => {
        toast.fire(
          "Update Business License Permit Type failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditType;
